// @flow
import * as React from 'react';
import SearchView from 'containers/search';
import { networkSearch } from 'api/content/search';
import SyndicationCopy from './NetworkSearchCopy';
import { NetworkQuestionFieldsets } from './SearchForm/config/forms.config';

const { primaryFieldsets } = NetworkQuestionFieldsets;

const label = 'Network Questions';
export default function NetworkQuestions(props: *) {
  const { hideCopy, ...rest } = props;

  return (
    <SearchView
      label={label}
      primaryFieldsets={primaryFieldsets}
      method={networkSearch}
      copy={hideCopy ? null : <SyndicationCopy />}
      {...rest}
    />
  );
}

NetworkQuestions.label = label;



// WEBPACK FOOTER //
// ./src/containers/search/NetworkQuestions.js